import chatBookingHelpers from '../../helpers/chatBookingHelpers'
import axios from 'axios'

const state = {
  messages: null,
  bookingData: null,
  queryParams: null,
  partner: null,
  tmpChatBookingCheckoutData: null,
  displayPopup: false
}

const actions = {
  fetchPartnerDetail: async ({commit}, queryParams) => {
    const url = '/partners'
    const {data} = await axios.get(url, {params: queryParams})
    if (!data.error) {
      commit('SET_PARTNER', data.partner)
    }
  }
}

const mutations = {
  CLEAR_MESSAGES: (state, removeBookingData) => {
    state.messages = []
    if (removeBookingData) {
      state.bookingData = null
    }
  },
  INIT_MESSAGE: (state, user) => {
    state.messages = []
    state.bookingData = null
    chatBookingHelpers.replyMainMenu(user)
  },
  ADD_MESSAGE: (state, message) => {
    state.messages.push({...message})
  },
  REMOVE_MESSAGE: (state) => {
    state.messages.pop()
  },
  UPDATE_BOOKING_DATA: (state, data) => {
    state.bookingData = {...state.bookingData, ...data}
  },
  SET_BOOKING_DATA: (state, data) => {
    state.bookingData = data
  },
  SET_QUERY_PARAMS: (state, queryParams) => {
    state.queryParams = queryParams
  },
  REMOVE_BOOKING_DATA: (state, key) => {
    delete state.bookingData[key]
  },
  SET_PARTNER: (state, partner) => {
    state.partner = partner
  },
  SET_TMP_CHAT_BOOKING_CHECKOUT_DATA: (state, data) => {
    state.tmpChatBookingCheckoutData = data
  },
  SET_DISPLAY_POPUP: (state, status) => {
    state.displayPopup = status
  }
}

const getters = {
  getState: state => {
    return state
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/chat.booking.js